import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { MomentumModal } from "@circle-react-shared/ModalsV2/MomentumModal";
import { ModalManager } from "../Layout/ModalManagerProvider";
import { Icon } from "../shared/Icon";
import { ActionButton } from "../shared/ModalsV2/MomentumModal/ActionButton";
import { ShareNotice } from "../shared/ModalsV2/MomentumModal/ShareNotice";
import type { PostForQuickPost } from "./Form";
import { useConvertPostToBroadcast } from "./useConvertPostToBroadcast";

export const PostMomentumModal = ModalManager.create(function PostMoMo({
  post,
}: {
  post: PostForQuickPost;
}) {
  const modal = useModal();
  const { onShareViaBroadcast, isLoading } = useConvertPostToBroadcast();

  const handleShareViaBroadcast = () => {
    onShareViaBroadcast({
      postId: post.id,
      onSuccess: () => void modal.hide(),
    });
  };

  return (
    <MomentumModal
      isOpen={modal.visible}
      onClose={modal.hide}
      title={t("quick_post_v2.connection_modal.title")}
      description={t("quick_post_v2.connection_modal.description", {
        space_name: post.space_name,
      })}
      isLoading={isLoading}
      data-testid="post-momentum-modal"
    >
      <ShareNotice>
        <ActionButton
          iconEl={<Icon type="20-page-edit-text" size={20} />}
          onClick={handleShareViaBroadcast}
          disabled={isLoading}
          data-testid="send-announcement-button"
        >
          {t("momentum_modal.share_broadcast.review_draft")}
        </ActionButton>
      </ShareNotice>
    </MomentumModal>
  );
});
